export const applyRealismStyle = async (canvas, ctx, setMessage, language) => {
  // 사실주의: 자연스러운 색감과 디테일 강화
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 1. 자연스러운 색감 조정
  for (let i = 0; i < data.length; i += 4) {
    // 피부톤 감지 및 자연스러운 보정
    const isLikelySkin = (data[i] > 60 && data[i + 1] > 40 && data[i + 2] > 20 && 
        data[i] > data[i + 2] && data[i + 1] > data[i + 2]);
    
    if (isLikelySkin) {
      // 피부톤을 더 자연스럽게
      data[i] = Math.min(255, data[i] * 1.02);
      data[i + 1] = Math.min(255, data[i + 1] * 1.01);
    }
    
    // 전체적인 색상 밸런스 조정
    const brightness = (data[i] + data[i + 1] + data[i + 2]) / 3;
    if (brightness < 50) {
      // 어두운 부분을 약간 밝게
      data[i] = Math.min(255, data[i] * 1.1);
      data[i + 1] = Math.min(255, data[i + 1] * 1.1);
      data[i + 2] = Math.min(255, data[i + 2] * 1.1);
    }
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 디테일 강화 (언샵 마스킹)
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  const detailData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const detailPixels = detailData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  for (let y = 1; y < canvas.height - 1; y++) {
    for (let x = 1; x < canvas.width - 1; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      for (let c = 0; c < 3; c++) {
        const current = tempData[pos + c];
        const surrounding = [
          tempData[((y - 1) * canvas.width + (x - 1)) * 4 + c],
          tempData[((y - 1) * canvas.width + x) * 4 + c],
          tempData[((y - 1) * canvas.width + (x + 1)) * 4 + c],
          tempData[(y * canvas.width + (x - 1)) * 4 + c],
          tempData[(y * canvas.width + (x + 1)) * 4 + c],
          tempData[((y + 1) * canvas.width + (x - 1)) * 4 + c],
          tempData[((y + 1) * canvas.width + x) * 4 + c],
          tempData[((y + 1) * canvas.width + (x + 1)) * 4 + c]
        ];
        
        const avgSurrounding = surrounding.reduce((sum, val) => sum + val, 0) / surrounding.length;
        const sharpened = current + (current - avgSurrounding) * 0.3;
        detailPixels[pos + c] = Math.min(255, Math.max(0, sharpened));
      }
    }
  }
  
  ctx.putImageData(detailData, 0, 0);
};